// extracted by mini-css-extract-plugin
var _1 = "Text-moduleactive__PEncV";
var _2 = "Text-modulebasic__Zy6o5";
var _3 = "Text-modulegrey__I2iAa";
var _4 = "Text-modulegreySecondary__DcG2i";
var _5 = "Text-moduletext__LMh0c";
var _6 = "Text-moduleunderline__diRPq";
export { _1 as "active", _2 as "basic", _3 as "grey", _4 as "greySecondary", _5 as "text", _6 as "underline" }
